import React from 'react';
import { useTranslation } from 'react-i18next';
import './IvrFunnelWidget.css';

/**
 * IvrFunnelWidget — entonnoir IVR par flow (KPI ivr-statistics). Agrège les nœuds d'un même
 * flow : Entrées → Option valide → Routés (actions.queue). Affiche aussi les fuites
 * (Abandon / Invalide / Timeout). Une section funnel par flow.
 */
const IvrFunnelWidget = ({ data, config }) => {
    const { t } = useTranslation();

    if (!Array.isArray(data) || data.length === 0) {
        return null;
    }

    const fmtInt = (v) => Number(v || 0).toLocaleString();
    const pct = (n, d) => (d > 0 ? (n / d) * 100 : 0);
    const fmtPct = (v) => {
        const n = Number(v);
        return `${n % 1 === 0 ? n.toFixed(0) : n.toFixed(1)}%`;
    };

    // Agrégation par flow.
    const flows = {};
    data.forEach((r) => {
        const k = r.flowName || '—';
        if (!flows[k]) {
            flows[k] = { flowName: k, entries: 0, validInput: 0, routed: 0, abandons: 0, invalid: 0, timeouts: 0 };
        }
        const f = flows[k];
        f.entries += Number(r.entries) || 0;
        f.validInput += Object.values(r.options || {}).reduce((acc, n) => acc + (Number(n) || 0), 0);
        f.routed += Number((r.actions || {}).queue) || 0;
        f.abandons += Number(r.abandons) || 0;
        f.invalid += Number(r.invalidInputs) || 0;
        f.timeouts += Number(r.timeouts) || 0;
    });

    return (
        <div className="ivr-fn-widget">
            {Object.values(flows).map((f, fi) => {
                const stages = [
                    { key: 'IVR_ENTRIES', value: f.entries, color: 'var(--heedify-primary)' },
                    { key: 'IVR_VALID_INPUT', value: f.validInput, color: 'var(--heedify-primary-hover)' },
                    { key: 'IVR_ROUTED', value: f.routed, color: 'var(--heedify-accent)' }
                ];
                const base = f.entries || 1;
                return (
                    <div className="ivr-fn-flow" key={fi}>
                        <div className="ivr-fn-flow-name">{f.flowName}</div>
                        <div className="ivr-fn-stages">
                            {stages.map((s, si) => (
                                <div className="ivr-fn-stage" key={si}>
                                    <div className="ivr-fn-stage-label">{t(s.key)}</div>
                                    <div className="ivr-fn-track">
                                        <div
                                            className="ivr-fn-fill"
                                            style={{ width: `${pct(s.value, base)}%`, background: s.color }}
                                        />
                                    </div>
                                    <div className="ivr-fn-stage-val">
                                        {fmtInt(s.value)} <span className="ivr-fn-stage-pct">({fmtPct(pct(s.value, base))})</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="ivr-fn-dropoffs">
                            <span className="ivr-fn-drop abandon">{t('ABANDON_IVR')}: {fmtInt(f.abandons)} ({fmtPct(pct(f.abandons, base))})</span>
                            <span className="ivr-fn-drop">{t('INVALID')}: {fmtInt(f.invalid)} ({fmtPct(pct(f.invalid, base))})</span>
                            <span className="ivr-fn-drop">{t('TIMEOUT')}: {fmtInt(f.timeouts)} ({fmtPct(pct(f.timeouts, base))})</span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default IvrFunnelWidget;
